/* istanbul ignore file */
const styles = ({
  palette: {
    grey: { G600 },
    text
  },
  spacing: { unit },
  typography
}) => ({
  row: {
    width: `calc(100% - ${unit * 2.5}px)`,
    float: 'left',
    padding: `0 ${unit * 3.5}px`,
    margin: `${unit * 2}px 0 0`,
    '& .flex-dropdown label': {
      display: 'block'
    },
    '& .flex-dropdown button': {
      fontWeight: typography.fontWeightRegular
    },
    '& .flex-dropdown.originator': {
      '& [data-qa="dropdown-position"]': {
        padding: [0, unit * 2],
        width: 'auto'
      },
      '& button': {
        whiteSpace: 'nowrap'
      }
    },
    '& label + [data-qa="dropdown-position"]': {
      width: '100%',
      left: 0,
      right: 'auto',
      padding: 0
    },
    '& label ~ [data-qa="dropdown-position"]': {
      zIndex: 10
    },
    '& .has-error+ .helpMessage': {
      display: 'none',
      marginTop: `${unit * 1.5}px`
    }
  },
  typeofBankCodes: {
    marginBottom: unit * 2
  },
  title: {
    textTransform: 'uppercase',
    fontSize: unit * 2.5,
    fontFamily: typography.headline2.fontFamily
  },
  bankDropDown: {
    '& .flex-dropdown': {
      position: 'relative'
    },
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginTop: 20,
    float: 'left'
  },
  adresses: {
    marginTop: -unit,
    display: 'flex',
    flexDirection: 'column',
    '& span': {
      fontSize: unit * 1.5,
      color: text.dark,
      textTransform: 'uppercase'
    }
  },
  addressBox: {
    display: 'flex',
    flexDirection: 'column',
    '& span': {
      fontSize: unit * 1.5,
      color: G600
    },
    '& > .form-group': {
      marginBottom: 0
    }
  }
});
export default styles;
